import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";

import { AuthService } from "../services/auth.service";

@Injectable({ providedIn: "root" })
export class AuthGuard {
  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    const user = this.authService.getUser();

    if (
      user &&
      user.jwtToken &&
      new Date(user.jwtToken.expiration) > new Date()
    ) {
      return true;
    }

    this.router.navigate(["/account/login"]);
    return false;
  }
}
